module.exports = __webpack_public_path__ + "img/bg.7cf999e6.png";